export default {
  requisicoes: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  activePolling: {},
}
